<template>
  <div>
    <el-card>
      <el-form ref="form" :inline="true">
        <el-form-item label="时间">
          <el-date-picker
            type="datetimerange"
            v-model="times"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="taskRecordList"
        stripe
        class="table"
        ref="userTable.multipleSelection"
        header-cell-class-name="table-header"
        border
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="时间" prop="date" align="center">
        </el-table-column>
        <el-table-column label="任务名" prop="item_ch" align="center"></el-table-column>
        <el-table-column label="任务类型" prop="type_ch" align="center"></el-table-column>
        <el-table-column label="任务奖励" prop="reward" align="center"></el-table-column>
        <el-table-column label="任务完成人" prop="user.nickname" align="center"></el-table-column>
        <el-table-column label="任务完成次数" prop="num" align="center"></el-table-column>

        <el-table-column label="创建时间" width="150" align="center">
          <template slot-scope="scope">
            {{$moment(scope.row.create_time * 1000).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>
       
      </el-table>

       <!-- 分页区域 -->
     <div class="pagination">
       <span></span>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.page"
        :page-sizes="[3, 5, 8, 10]"
        :page-size="queryForm.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        algin:="center"
      ></el-pagination>
     </div>

    </el-card>
  </div>
</template>

<script>
import { TaskRecord } from "@/api/taskList.js";

export default {
  data() {
    return {
      queryForm: {
        page: 1,
        limit: 10,
        start_time: null,
        end_time: null,
      },
      total: 0,
      times: null,
      taskRecordList: [],
    };
  },
  created() {
    this.getTaskRecord();
  },
  methods: {
    //   获取任务列表
    getTaskRecord() {
      TaskRecord(this.queryForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.total = res.data.total;
        this.taskRecordList = res.data.data;
        console.log(this.taskRecordList);
      });
    },

    //  查询
    toQuery() {
      this.queryForm.page = 1;
      if (this.times) {
        this.queryForm.start_time = new Date(this.times[0]).getTime() / 1000;
        this.queryForm.end_time = new Date(this.times[1]).getTime() / 1000;
      } else if (this.times == null) {
        this.queryForm.start_time = null;
        this.queryForm.end_time = null;
      }
      this.getTaskRecord();
    },
    handleSizeChange(size) {
      this.queryForm.limit = size;
      this.getTaskRecord();
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getTaskRecord();
    },
  },
};
</script>

<style scoped>
.generate {
  float: right;
}
.el-tag {
  cursor: pointer;
}
::v-deep .ql-editor {
  min-height: 400px;
}
</style>
